export default "__VITE_ASSET__QHYCUKMU__"